<template>
    <section class="FeatureBlock" :id=block_id>
        <div class="bg-white">
            <div class="container-block">
                <div class="grid gap-8 md:gap-12 lg:grid-cols-2 xl:gap-24">

                    <!-- Image -->
                    <div class="grid place-items-center">
                        <picture>
                            <img class="object-cover w-full aspect-[3/2] rounded-lg md:rounded-xl" :alt=image.alt :src=image.file loading="lazy">
                        </picture>
                    </div>

                    <!-- Text -->
                    <div class="flex flex-col justify-center">
                        
                        <!-- Byline -->
                        <p class="mb-0.5 font-bold body-md text-neutral-500">{{ byline }}</p>

                        <!-- Headline -->
                        <h2 class="mb-4 head-md text-neutral-800">{{ headline }}</h2>

                        <!-- Copy -->
                        <div class="body-md text-neutral-600 copy max-w-[56ch]">
                            <p v-for="line in copy" :key="line.id">{{ line }}</p>
                        </div>

                        <!-- CTA -->
                        <div class="flex flex-wrap gap-4 mt-4 lg:mt-6">
                            <a :href=cta.url target="_blank" class="btn btn-md btn-filled btn-secondary">{{ cta.text }}</a>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>

    export default {
        name: 'FeatureBlock',

        props: {
            content: Object, // Hero Content
        },
        
        data(){
            return {
                block_id: this.content.block_id,
                byline: this.content.byline,
                headline: this.content.headline,
                copy: this.content.copy,
                cta: this.content.cta,
                image: this.content.image,
            }
        }
    }

</script>